import React, { useEffect, useRef } from 'react';

export default function AIRepellantHero({ catalog, minimal }) {
  var canRef = useRef(null);

  useEffect(function() {
    if (minimal) return;
    var can = canRef.current;
    if (!can) return;
    var frame;
    var start = null;

    function animate(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      var wobble = Math.sin(elapsed / 600) * 4;
      var float = Math.sin(elapsed / 900) * 8;
      can.style.transform = 'translateY(' + (float) + 'px) rotate(' + wobble + 'deg)';
      frame = requestAnimationFrame(animate);
    }

    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (!mq.matches) {
      frame = requestAnimationFrame(animate);
    }

    return function() { cancelAnimationFrame(frame); };
  }, [minimal]);

  return (
    <>
      <style>{`
        .air-hero {
          position: relative;
          background: #0a0a0a;
          min-height: 480px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          padding: 3rem 2rem;
        }
        .air-hero-bg {
          position: absolute;
          inset: 0;
          background:
            radial-gradient(ellipse 60% 50% at 70% 50%, rgba(0,255,120,0.07) 0%, transparent 70%),
            radial-gradient(ellipse 40% 60% at 30% 80%, rgba(0,200,255,0.05) 0%, transparent 60%);
        }
        .air-hero-grid {
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
          background-size: 40px 40px;
        }
        .air-hero-inner {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          gap: 4rem;
          max-width: 900px;
          width: 100%;
        }
        .air-can-wrap {
          flex-shrink: 0;
          width: 180px;
          height: 280px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .air-can {
          width: 120px;
          height: 240px;
          background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 40%, #1a1a1a 100%);
          border-radius: 12px 12px 8px 8px;
          position: relative;
          border: 1px solid rgba(255,255,255,0.1);
          box-shadow:
            inset 2px 0 8px rgba(255,255,255,0.05),
            0 20px 60px rgba(0,0,0,0.5);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 16px 12px;
        }
        .air-can::before {
          content: '';
          position: absolute;
          top: -8px;
          left: 50%;
          transform: translateX(-50%);
          width: 28px;
          height: 12px;
          background: #333;
          border-radius: 4px 4px 0 0;
          border: 1px solid rgba(255,255,255,0.1);
        }
        .air-can::after {
          content: '';
          position: absolute;
          top: -16px;
          left: 50%;
          transform: translateX(-50%);
          width: 10px;
          height: 10px;
          background: #555;
          border-radius: 50%;
          border: 1px solid rgba(255,255,255,0.15);
        }
        .air-can-logo {
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.15em;
          color: rgba(255,255,255,0.4);
          text-transform: uppercase;
        }
        .air-can-name {
          font-size: 13px;
          font-weight: 800;
          color: #00ff88;
          text-align: center;
          line-height: 1.2;
          letter-spacing: -0.01em;
        }
        .air-can-sub {
          font-size: 8px;
          color: rgba(255,255,255,0.35);
          text-align: center;
          letter-spacing: 0.1em;
          text-transform: uppercase;
          line-height: 1.4;
        }
        .air-can-stripe {
          width: 100%;
          height: 2px;
          background: linear-gradient(90deg, transparent, #00ff88, transparent);
          opacity: 0.4;
        }
        .air-hero-copy {
          flex: 1;
        }
        .air-badge {
          display: inline-block;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #00ff88;
          border: 1px solid rgba(0,255,136,0.3);
          padding: 4px 10px;
          border-radius: 99px;
          margin-bottom: 1rem;
        }
        .air-hero-h1 {
          font-size: clamp(2rem, 4vw, 3rem);
          font-weight: 900;
          color: #ffffff;
          line-height: 1.05;
          letter-spacing: -0.03em;
          margin: 0 0 1rem;
        }
        .air-hero-h1 em {
          font-style: normal;
          color: #00ff88;
        }
        .air-hero-p {
          font-size: 1rem;
          color: rgba(255,255,255,0.55);
          line-height: 1.6;
          margin: 0;
          max-width: 380px;
        }
        @media (max-width: 640px) {
          .air-hero-inner {
            flex-direction: column;
            gap: 2rem;
            text-align: center;
          }
          .air-can-wrap {
            width: 120px;
            height: 200px;
          }
          .air-can {
            width: 90px;
            height: 180px;
          }
          .air-hero-p {
            max-width: 100%;
          }
        }
      `}</style>
      <div className="air-hero">
        <div className="air-hero-bg"></div>
        <div className="air-hero-grid"></div>
        <div className="air-hero-inner">
          <div className="air-can-wrap">
            <div className="air-can" ref={canRef}>
              <span className="air-can-logo">Funky Mailers</span>
              <div className="air-can-stripe"></div>
              <span className="air-can-name">AI<br/>Repellant</span>
              <div className="air-can-stripe"></div>
              <span className="air-can-sub">Aromatherapy<br/>Room Spray<br/>4 fl oz</span>
            </div>
          </div>
          <div className="air-hero-copy">
            <div className="air-badge">Limited Drop</div>
            <h1 className="air-hero-h1">
              Keep the robots<br/>out of the <em>room.</em>
            </h1>
            <p className="air-hero-p">
              A custom-labeled aromatherapy room spray for teams who want to stay human in an AI-everything world. Claim yours before they're gone.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
